module.exports = __webpack_public_path__ + "static/media/health-safety-measures.7d5edce4.svg";